import { ApiProperty } from "@nestjs/swagger";


export class RfCodeCreateRequest {
    @ApiProperty()
    rfCodes: string[];
    @ApiProperty()
    username: string;     

    /**
     * 
     * @param rfCodes
     * @param username 
     */
    constructor(rfCodes: string[], username: string) {
        this.rfCodes = rfCodes;
        this.username = username;
    }
}
